import React, { Component } from 'react';
import * as ReactDOM from 'react-dom';
import {inject, observer} from 'mobx-react';
import {TextButton} from '../Buttons';
import styles from './style.css';

@inject('localizationStore')
@observer
class DialogModal extends Component {
    onWindowClick = (event) => {
        event.stopPropagation()
    }
    render() {
        const locale = this.props.localizationStore.locale
        return ReactDOM.createPortal((
            <div className={styles.modalContainer} onClick={this.props.onClose} >

                <div className={styles.window} onClick={this.onWindowClick}>
                    <div className={styles.content}>
                        {this.props.children}
                        <div className={styles.buttons}>
                            <TextButton style={styles.closeBtn} text={locale.close} onClick={this.props.onClose}/>
                            {this.props.button !== undefined && this.props.button}
                        </div>
                    </div>
                </div>
            </div>
            ),
            document.getElementById('dialogModal')
        );
    }
}

export default DialogModal;


// WEBPACK FOOTER //
// ./src/components/DialogModal/index.js